var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"max-box"},[_c('div',{staticClass:"fool-btn flex_c_m"},[_c('van-button',{staticClass:"btn-green",attrs:{"type":"default","to":{path:'/lineVote',query:{voteId:_vm.voteId}}}},[_vm._v("登录")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }